module.exports = __webpack_public_path__ + "img/cloud-arrow-down.d604815f.svg";